import React from 'react';
import sortBy from 'lodash.sortby';
import TypeNav from './TypeNav';
import TypeIframe from './TypeIframe';
import TypeModalMedias from './TypeModalMedias';
import TypeSlideshow from './TypeSlideshow';
import { FiChevronRight } from 'react-icons/fi';
export default {
  nav: {
    render: TypeNav,
    debug: function debug(_ref) {
      var str = _ref.str,
          region = _ref.region;
      return /*#__PURE__*/React.createElement("span", null, str, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FiChevronRight, null), region.settings.pageId);
    }
  },
  modal: {
    render: TypeModalMedias,
    props: function props(_ref2) {
      var region = _ref2.region;
      var medias = region.medias && region.medias.length ? [region.medias[0]] : [];
      return {
        multiple: false,
        medias: medias
      };
    }
  },
  iframe: {
    render: TypeIframe
  },
  slideshow: {
    render: TypeSlideshow,
    props: function props(_ref3) {
      var region = _ref3.region;
      var medias = region.medias ? sortBy(region.medias, [function (o) {
        return o.contentUrl.slice(14);
      }]) : [];
      return {
        multiple: true,
        medias: medias
      };
    }
  }
};